module.exports = __webpack_public_path__ + "static/media/newUser.96076b05.png";